import { render, staticRenderFns } from "./channelAdPlanSet.vue?vue&type=template&id=3398e176&"
import script from "./channelAdPlanSet.vue?vue&type=script&lang=js&"
export * from "./channelAdPlanSet.vue?vue&type=script&lang=js&"
import style0 from "./channelAdPlanSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports